const resourceTypePaths = {
  RESOURCE_TYPE: "",
  SEARCH_RESOURCE_TYPE: "search",
  RESOURCE_TYPE_ID: (resourceTypeId) => resourceTypeId,
};

export default resourceTypePaths;
